import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import {
  fetchFoods,
  fetchFoodsByCategory,
} from '~/services/foodsService/foods.service';
import { useLocale } from './useLocale';
import { FoodResponseDto } from '@bitecritic-api/src/foods/dto/food.response.dto';

export const useFood = (searchTerm: string, initialFood?: FoodResponseDto, limit = 20) => {
  const { i18n } = useTranslation();
  const language = i18n.language.split('-')[0] as
    | 'en'
    | 'fr'
    | 'es'
    | 'de'
    | 'it'
    | 'tr';

  const initialData = initialFood
    ? {
        items: [initialFood],
        total: 1,
        page: 1,
        totalPages: 1,
        hasMore: false,
      }
    : undefined;

  return useQuery({
    initialData,
    queryKey: ['foods', searchTerm, language, limit],
    queryFn: () => fetchFoods(searchTerm, language, limit),
    enabled: searchTerm.length > 2 && initialFood?.name !== searchTerm,
  });
};

export const useFoodsByCategoryService = (categoryId?: number) => {
  const { currentLocale } = useLocale();

  return useQuery({
    queryKey: ['foods', 'category', categoryId, currentLocale.language],
    queryFn: () => fetchFoodsByCategory(categoryId!, currentLocale.language),
    enabled: !!categoryId && Number.isInteger(categoryId) && categoryId > 0,
  });
};
